import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';

import './index.css';
import App from './App';
import SWWPage from 'initializers/envs/SWW';
import reportWebVitals from './reportWebVitals';
import { Authenticator } from '@aws-amplify/ui-react';
import { LocaleProvider } from 'contexts/localeContext';
import { ToastProvider } from 'contexts/toastContext';
import { LabelOptionsProvider } from 'contexts/labelOptionsContext';
import { AuthContextProvider } from 'contexts/authContext';
import CrashPage from 'components/CrashPage';
import sentryInitializer from 'initializers/sentry';
import envsInitializer from 'initializers/envs';
import appInsightsInitializer from 'initializers/appInsights';
import smartlookInitializer from 'initializers/smartlook';
import awsAmplifyInitializer from 'initializers/awsAmplify';

const root = ReactDOM.createRoot(document.getElementById('root'));

sentryInitializer();
envsInitializer().then(() => {
  appInsightsInitializer();
  smartlookInitializer();
  awsAmplifyInitializer();

  root.render(
    <Authenticator.Provider>
      <LabelOptionsProvider>
        <LocaleProvider>
          <ToastProvider>
            <AuthContextProvider>
              <Sentry.ErrorBoundary fallback={<CrashPage />}>
                <App />
              </Sentry.ErrorBoundary>
            </AuthContextProvider>
          </ToastProvider>
        </LocaleProvider>
      </LabelOptionsProvider>
    </Authenticator.Provider>,
  );
}).catch((err) => {
  root.render(<SWWPage />)
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
